// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Button from "react-bootstrap/Button";
// import Col from "react-bootstrap/Col";
// import Form from "react-bootstrap/Form";
// import Row from "react-bootstrap/Row";
// import "./Application.css";
// import NavigationBar from "../../Components/NavigationBar";

// function ApplicationForm() {
//   const [awards, setAwards] = useState([]);
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const [formData, setFormData] = useState({
//     name: "",
//     awardType: "",
//     email: "",
//     contactNumber: "",
//     file: null,
//   });

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getAwards`)
//       .then((response) => {
//         setAwards(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching awards:", error);
//       });
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setFormData({ ...formData, file: file });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Retrieve the user_id from localStorage
//     const userId = localStorage.getItem("user_id");

//     // If no user_id is found, show an alert and prevent the form submission
//     if (!userId) {
//       alert("Please log in first.");
//       return;
//     }

//     // Get the Application_ID and AwardType from the form
//     const applicationID = "12345"; // Replace with actual Application ID logic
//     const awardType = formData.awardType;

//     // Rename the file
//     const file = formData.file;
//     const fileExtension = file.name.split(".").pop(); // Get the file extension
//     const renamedFileName = `${applicationID}_${awardType}.${fileExtension}`;

//     // Create a new FormData object
//     const formDataToSend = new FormData();
//     formDataToSend.append("name", formData.name);
//     formDataToSend.append("awardType", formData.awardType);
//     formDataToSend.append("email", formData.email);
//     formDataToSend.append("contactNumber", formData.contactNumber);
//     formDataToSend.append("userId", userId); // Add userId to the form data

//     // Append the renamed file
//     formDataToSend.append("file", file, renamedFileName);

//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/submitForm`,
//         formDataToSend,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       alert(response.data.message);
//       setFormData({
//         name: "",
//         awardType: "",
//         email: "",
//         contactNumber: "",
//         file: null,
//       });
//     } catch (error) {
//       console.error("Error submitting form:", error);
//       alert("Error submitting form. Please try again.");
//     }
//   };

 

//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-title">Award Application Form</h1>
//       <div className="form-container">
//         <Form className="my-form" onSubmit={handleSubmit}>
//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Full Name with Initials:</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Enter your full name with initials"
//                 required
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Award Type:</Form.Label>
//               <Form.Control
//                 as="select"
//                 name="awardType"
//                 value={formData.awardType}
//                 onChange={handleChange}
//                 required
//               >
//                 <option value="">Choose Award Type</option>
//                 {awards.map((award) => (
//                   <option key={award.Award_Id} value={award.Award_Id}>
//                     {award.Name}
//                   </option>
//                 ))}
//               </Form.Control>
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Email Address:</Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 placeholder="Enter your Email"
//                 required
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Contact Number:</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="contactNumber"
//                 value={formData.contactNumber}
//                 onChange={handleChange}
//                 placeholder="Enter your Contact Number"
//                 required
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Upload Application:</Form.Label>
//               <Form.Control type="file" onChange={handleFileChange} required />
//             </Form.Group>
//           </Row>
//            <p className="note">
//                🛑 Note : If there are any required documents, please attach them to the application form as a single PDF.
//                 </p>

//           <Button variant="primary" type="submit" className="form-btn">
//             Submit
//           </Button>
//         </Form>
//       </div>
//     </div>
//   );
// }

// export default ApplicationForm;


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Button from "react-bootstrap/Button";
// import Col from "react-bootstrap/Col";
// import Form from "react-bootstrap/Form";
// import Row from "react-bootstrap/Row";
// import "./Application.css";
// import NavigationBar from "../../Components/NavigationBar";

// function ApplicationForm() {
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
//   const [awards, setAwards] = useState([]);
//   const [formData, setFormData] = useState({
//     name: "",
//     awardType: "",
//     email: "",
//     contactNumber: "",
//     file: null,
//   });

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/getAwards`)
//       .then((response) => {
//         setAwards(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching awards:", error);
//       });
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setFormData({ ...formData, file: file });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Retrieve the user_id from localStorage
//     const userId = localStorage.getItem("user_id");

//     // Validate user_id
//     if (!userId) {
//       alert("Please log in first.");
//       return;
//     }

//     // Validate form fields
//     if (!formData.name || !formData.awardType || !formData.email || !formData.contactNumber || !formData.file) {
//       alert("Please fill in all required fields.");
//       return;
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       alert("Please enter a valid email address.");
//       return;
//     }

//     // Get the Application_ID and AwardType from the form
//     const applicationID = "12345"; // Replace with actual Application ID logic
//     const awardType = awards.find(award => award.Award_Id === formData.awardType)?.Name || formData.awardType;

//     // Rename the file
//     const file = formData.file;
//     const fileExtension = file.name.split(".").pop();
//     const renamedFileName = `${applicationID}_${awardType}.${fileExtension}`;

//     // Create a new FormData object
//     const formDataToSend = new FormData();
//     formDataToSend.append("name", formData.name);
//     formDataToSend.append("awardType", formData.awardType);
//     formDataToSend.append("email", formData.email);
//     formDataToSend.append("contactNumber", formData.contactNumber);
//     formDataToSend.append("userId", userId);
//     formDataToSend.append("file", file, renamedFileName);

//     try {
//       // Submit the form
//       const submitResponse = await axios.post(
//         `${API_BASE_URL}/submitForm`,
//         formDataToSend,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       // Send confirmation email
//       const emailSubject = "Application Submission Confirmation";
//       const emailBody = `Dear ${formData.name},\n\nYour application has been submitted successfully. We will review your submission and contact you with further updates.\n\nThank you for applying!\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nURC Director`;

//       const emailResponse = await axios.post(`${API_BASE_URL}/sendEmail`, {
//         to: formData.email,
//         subject: emailSubject,
//         text: emailBody,
//         html: `<p>${emailBody.replace(/\n/g, '<br>')}</p>`,
//       });

  

//       alert(`${submitResponse.data.message}\n${emailResponse.data.message}`);
//       setFormData({
//         name: "",
//         awardType: "",
//         email: "",
//         contactNumber: "",
//         file: null,
//       });
//     } catch (error) {
//       console.error("Error submitting form or sending email:", error);
//       alert("Error submitting form or sending email. Please try again.");
//     }
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-title">Award Application Form</h1>
//       <div className="form-container">
//         <Form className="my-form" onSubmit={handleSubmit}>
//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Full Name with Initials:</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Enter your full name with initials"
//                 required
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Award Type:</Form.Label>
//               <Form.Control
//                 as="select"
//                 name="awardType"
//                 value={formData.awardType}
//                 onChange={handleChange}
//                 required
//               >
//                 <option value="">Choose Award Type</option>
//                 {awards.map((award) => (
//                   <option key={award.Award_Id} value={award.Award_Id}>
//                     {award.Name}
//                   </option>
//                 ))}
//               </Form.Control>
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Email Address:</Form.Label>
//               <Form.Control
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 placeholder="Enter your Email"
//                 required
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Contact Number:</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="contactNumber"
//                 value={formData.contactNumber}
//                 onChange={handleChange}
//                 placeholder="Enter your Contact Number"
//                 required
//               />
//             </Form.Group>
//           </Row>

//           <Row className="mb-3">
//             <Form.Group as={Col} md="12">
//               <Form.Label>Upload Application:</Form.Label>
//               <Form.Control type="file" onChange={handleFileChange} required />
//             </Form.Group>
//           </Row>
//           <p className="note">
//             🛑 Note: If there are any required documents, please attach them to the application form as a single PDF.
//           </p>

//           <Button variant="primary" type="submit" className="form-btn">
//             Submit
//           </Button>
//         </Form>
//       </div>
//     </div>
//   );
// }

// export default ApplicationForm;


import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "./Application.css";
import NavigationBar from "../../Components/NavigationBar";

function ApplicationForm() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const [awards, setAwards] = useState([]);
  const [applicationDates, setApplicationDates] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    awardType: "",
    email: "",
    contactNumber: "",
    file: null,
  });

  useEffect(() => {
    // Fetch awards
    const fetchAwards = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getAwards`);
        console.log('Awards API Response:', response.data);
        setAwards(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching awards:", error);
        setAwards([]);
      }
    };

    // Fetch application dates (inspired by Grant.js)
    const fetchApplicationDates = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/getApplicationDates`);
        console.log('Application Dates API Response:', response.data);
        setApplicationDates(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching application dates:", error);
        setApplicationDates([]);
      }
    };

    fetchAwards();
    fetchApplicationDates();
  }, []);

  // Function to check if an award is open based on current date/time (inspired by Grant.js)
  const isAwardOpen = (awardId) => {
    const now = new Date(); // Current date/time: July 08, 2025, 03:08 PM +0530
    const dateRecord = applicationDates.find((date) => date.Award_Type.toString() === awardId.toString());

    if (!dateRecord) {
      console.warn(`No application date record found for Award_Type: ${awardId}`);
      return false;
    }

    console.log(`Raw dateRecord for Award_Type: ${awardId}`, dateRecord);

    try {
      // Extract YYYY-MM-DD from Start_Date and End_Date, removing T18:30:00.000Z
      const startDate = dateRecord.Start_Date?.split('T')[0]?.trim();
      const startTime = dateRecord.Start_Time?.trim();
      const endDate = dateRecord.End_Date?.split('T')[0]?.trim();
      const endTime = dateRecord.End_Time?.trim();

      if (!startDate || !startTime || !endDate || !endTime) {
        console.warn(`Missing date/time fields for Award_Type: ${awardId}`, dateRecord);
        return false;
      }

      // Combine date and time: YYYY-MM-DD HH:mm:ss
      const startDateTime = new Date(`${startDate} ${startTime}`);
      const endDateTime = new Date(`${endDate} ${endTime}`);

      // Validate dates
      if (isNaN(startDateTime.getTime()) || isNaN(endDateTime.getTime())) {
        console.warn(`Invalid date/time for Award_Type: ${awardId}`, {
          startInput: `${startDate} ${startTime}`,
          endInput: `${endDate} ${endTime}`,
          startDateTime,
          endDateTime,
        });
        return false;
      }

      // Log dates in local timezone for debugging
      console.log(`Award ${awardId} - Start: ${startDateTime.toLocaleString()}, End: ${endDateTime.toLocaleString()}, Now: ${now.toLocaleString()}`);
      return now >= startDateTime && now <= endDateTime;
    } catch (error) {
      console.warn(`Error parsing date/time for Award_Type: ${awardId}`, dateRecord, error);
      return false;
    }
  };

  // Check if any awards are open
  const hasOpenAwards = awards.some((award) => isAwardOpen(award.Award_Id));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, file: file });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Retrieve the user_id from localStorage
    const userId = localStorage.getItem("user_id");

    // Validate user_id
    if (!userId) {
      alert("Please log in first.");
      return;
    }

    // Validate form fields
    if (!formData.name || !formData.awardType || !formData.email || !formData.contactNumber || !formData.file) {
      alert("Please fill in all required fields.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Validate awardType is open
    if (!isAwardOpen(formData.awardType)) {
      alert("The selected award is not currently open for applications.");
      return;
    }

    // Get the Application_ID and AwardType from the form
    const applicationID = "12345"; // Replace with actual Application ID logic
    const awardType = awards.find(award => award.Award_Id === formData.awardType)?.Name || formData.awardType;

    // Rename the file
    const file = formData.file;
    const fileExtension = file.name.split(".").pop();
    const renamedFileName = `${applicationID}_${awardType}.${fileExtension}`;

    // Create a new FormData object
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("awardType", formData.awardType);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("contactNumber", formData.contactNumber);
    formDataToSend.append("userId", userId);
    formDataToSend.append("file", file, renamedFileName);

    try {
      // Submit the form
      const submitResponse = await axios.post(
        `${API_BASE_URL}/submitForm`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Send confirmation email
      const emailSubject = "Application Submission Confirmation";
      const emailBody = `Dear ${formData.name},\n\nYour application has been submitted successfully. We will review your submission and contact you with further updates.\n\nThank you for applying!\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nURC Director`;

      const emailResponse = await axios.post(`${API_BASE_URL}/sendEmail`, {
        to: formData.email,
        subject: emailSubject,
        text: emailBody,
        html: `<p>${emailBody.replace(/\n/g, '<br>')}</p>`,
      });

      alert(`${submitResponse.data.message}\n${emailResponse.data.message}`);
      setFormData({
        name: "",
        awardType: "",
        email: "",
        contactNumber: "",
        file: null,
      });
    } catch (error) {
      console.error("Error submitting form or sending email:", error);
      alert("Error submitting form or sending email. Please try again.");
    }
  };

  return (
    <div>
      <NavigationBar />
      <h1 className="page-title">Award Application Form</h1>
      <div className="form-container">
        <Form className="my-form" onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>Full Name with Initials:</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name with initials"
                required
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>Award Type:</Form.Label>
              <Form.Control
                as="select"
                name="awardType"
                value={formData.awardType}
                onChange={handleChange}
                required
                disabled={awards.length === 0}
              >
                <option value="">Choose Award Type</option>
                {awards.map((award) => (
                  <option
                    key={award.Award_Id}
                    value={award.Award_Id}
                    disabled={!isAwardOpen(award.Award_Id)}
                  >
                    {award.Name} {isAwardOpen(award.Award_Id) ? '' : '(Closed)'}
                  </option>
                ))}
              </Form.Control>
              {applicationDates.length === 0 && (
                <p className="no-awards-note">
                  No active awards available at this time. All awards are currently closed.
                </p>
              )}
              {applicationDates.length > 0 && !hasOpenAwards && (
                <p className="no-awards-note">
                  No awards are currently open for applications.
                </p>
              )}
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>Email Address:</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your Email"
                required
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>Contact Number:</Form.Label>
              <Form.Control
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                placeholder="Enter your Contact Number"
                required
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12">
              <Form.Label>Upload Application:</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} required />
            </Form.Group>
          </Row>
          <p className="note">
            🛑 Note: If there are any required documents, please attach them to the application form as a single PDF.
          </p>

          <Button variant="primary" type="submit" className="form-btn">
            Submit
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default ApplicationForm;